module.exports = __webpack_public_path__ + "static/looprobust-83a6610f584f248af5e6fd35222b2065.png";